
























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import HotelPolicyService from "@/service/hotelPolicyService";
import { Cell, Search, Empty, Tag } from "vant";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";

@Component({
  name: "addKeywords",
  components: {
    [Cell.name]: Cell,
    [Search.name]: Search,
    [Empty.name]: Empty,
    [Tag.name]: Tag,
  },
})
export default class extends Vue {
  //data
  Keywords: string = "";
  keywordList = [];
  mounted() {
    this.Keywords = dataShare.keyword.Keyword;
  }
  get ZoneID() {
    return this.$route.query.ZoneID.toString();
  }
  get CityName() {
    return this.$route.query.CityName;
  }
  getKeywordData() {
    // const data = { ZoneId: this.ZoneID, Keyword: this.Keywords };
    this.keywordList=[]
    const data = { Keyword: this.Keywords };
    HotelPolicyService.getKeyword(data).then(res => {
      if (res.isSucc && res.result) {
        res.result.forEach((ent: any) => {
          ent.Keyword = ent.Keyword.replace(", " + ent.ZoneName, "");
          ent.CityID = ent.ZoneId;
          ent.CityName = ent.ZoneName;
        });
        this.keywordList = res.result;
      }
    });
  }
  selectKeyWord(value: any) {
    dataShare.name=''
    dataShare.keyword = value;
    if (value.CityID && value.CityID != this.ZoneID) {
      dataShare.City = {
        OrderBy: 2,
        label: value.CityName,
        originID: value.CityID,
        originName: value.CityName,
        type: "城市",
        ZoneID: value.CityID,
        ZoneName: value.CityName,
        ZoneType: "1444",
        CountryID: 151,
        CityID: value.CityID,
        CityCode: "",
        CitySpell: "",
        CityName: value.CityName,
      };
    }
    this.back();
  }

  enterKeywords() {
    this.selectKeyWord({ ZoneId: "", Keyword: this.Keywords });
  }
  cancel() {
    this.Keywords = "";
  }
  back() {
    history.back();
  }
  @Watch("Keywords", { deep: true })
  handleWatch(newVal: string, oldVal: string) {
    if (newVal == "") {
      return;
    }
    this.getKeywordData();
  }
}
